import React, { useEffect, useRef, useState } from 'react'
import config from '../../../../../config/config';
import { useIsDesktop } from '../../../../../hooks/index';
import './NftGallery.scss';

export const NftGallery = () => {
    const ref = useRef(null);
    const galleryRef = useRef(null);
    const [nftGalleryList, setNftGalleryList] = useState(config.nftGalleryList);
    const [activeNft, setActiveNft] = useState(2);
    const isDesktop = useIsDesktop();
    const [isNext, setIsNext] = useState();

    const galleryClassList = {
        "gallery-item-first": 0,
        "gallery-item-previous": 1,
        "gallery-item-selected": 2,
        "gallery-item-next": 3,
        "gallery-item-last": 4,
    }

    const [nftAnimationClasses, setNftAnimationClasses] = useState(Object.keys(galleryClassList));

    const nextImage = () => {
        setIsNext(true);
        if(isDesktop) {
            setNftAnimationClasses(prev => [...prev.slice(1, prev.length), prev[0]]);
        } else {
            setActiveNft(prev => prev <= 0 ? nftGalleryList.length-1 : prev-1)
            setNftGalleryList(prev => [prev[prev.length - 1], ...prev.slice(0, prev.length-1)]);
        }
    }

    const prevImage = () => {
        setIsNext(false);
        if(isDesktop) {
            setNftAnimationClasses(prev => [prev[prev.length-1], ...prev.slice(0, prev.length-1)]);
        } else {
            setActiveNft(prev => prev >= nftGalleryList.length-1 ? 0 : prev+1)
            setNftGalleryList(prev => [prev[prev.length-1], ...prev.slice(0, prev.length-1)]);
        }
    }

    const onClickImage = (index) => {
        const currentClickedImageClass = galleryRef.current?.children?.[index]?.classList?.[1];
        const currentIndex = galleryClassList?.[currentClickedImageClass];

        if(currentClickedImageClass) {
            _clearInterval();
            startInterval();

            if(currentIndex > 2) {
                nextImage();
            } else if(currentIndex < 2) {
                prevImage();
            }
        }
    }

    const _clearInterval = () => {
        if(ref.current) clearInterval(ref.current);
    }

    const startInterval = () => {
        ref.current = setInterval(() => {
            nextImage();
        }, 6000);
    }

    useEffect(() => {
        if(!isDesktop) {
            setNftAnimationClasses(Object.keys(galleryClassList));
        }
        startInterval();
        return () => _clearInterval();
        //eslint-disable-next-line
    }, [isDesktop]);

    return (
        <div className="nft-gallery-component">
            <div className="nft-gallery-component__container" ref={galleryRef}>
                {nftGalleryList.map((nftData, index) => <NftCard key={index} index={index} isNext={isNext} nftData={nftData} onClick={() => onClickImage(index)} className={nftAnimationClasses[index]} />)}
            </div>
            {!isDesktop && <div className="nft-gallery-component__container--dots">
                {config.nftGalleryList.map((item, index) => <div className={activeNft === index ? 'active' : ''} key={index} ></div>)}
            </div>}
        </div>
    )
}

const NftCard = ({nftData: { 
    author,
    authorImage,
    fileName,
}, className, onClick, index, isNext}) => {
    return (
        <div className={`nft-card-component ${className ?? ''} ${isNext ? 'is-next' : 'is-prev'}`} onClick={onClick}>
            <div className="nft-card-component__container">
                <img src={require(`../../../../../images/nfts/${fileName}`).default} alt={fileName} />
                {author && <div className="nft-card-component__container--footer">
                    <div className="nft-card-component__container--footer-author"> 
                        {authorImage && <div></div> }
                        <span>Created by {author}</span>
                    </div>
                    {/* <img src={require('../../../../../images/icons/view-icon.svg').default} alt="view" /> */}
                </div> }
            </div>
        </div>
    )
}

export default NftGallery;